<template lang="html">
  <i-btn
    color="info"
    icon="mdi-content-copy"
    @click="$emit('click', $event)"/>
</template>

<script>
import IconButton from './IconButton'

export default {
  components: {
    'i-btn': IconButton
  }
}
</script>

<style lang="css" scoped>
</style>
